var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    fill: "url(#paint0_linear_24485_183161)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.28571C1 1.57563 1.59695 1 2.33333 1H19.6667C24.8213 1 29 5.02944 29 10C29 14.9706 24.8213 19 19.6667 19H2.33333C1.59696 19 1 18.4244 1 17.7143V2.28571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9233 9.21619C25.9233 8.84091 25.6597 8.64139 25.1756 8.64139H24.9407V9.82423H25.166C25.6597 9.82423 25.9233 9.61522 25.9233 9.21619ZM24.1738 8.01909C25.2571 8.01909 26.7094 7.82432 26.7094 9.17818C26.7094 9.77673 26.3931 10.1615 25.8131 10.2803L27.0497 11.9144H26.1103L25.0462 10.3563H24.9407V11.9144H24.1738V8.01909ZM21.4944 8.02384H23.6657V8.68889H22.2613V9.55346H23.6178V10.209H22.2613V11.2636H23.6657V11.9192H21.4944V8.02384ZM18.2015 8.02384L19.2512 10.6461L20.3153 8.02384H21.1541L19.4525 12.0237H19.0403L17.3627 8.02384H18.2015ZM13.1591 8.1711V9.07368C12.1957 8.11885 10.9159 8.85041 10.9159 9.97625C10.9159 11.1638 12.234 11.8051 13.1591 10.8883V11.7909C11.7355 12.4702 10.125 11.5201 10.125 9.97625C10.125 8.49413 11.7116 7.45855 13.1591 8.1711ZM8.50012 11.3206C9.04654 11.3206 9.57379 10.5938 8.34195 10.1615C7.62297 9.90024 7.37372 9.61997 7.37372 9.08318C7.37372 7.98109 8.84044 7.59156 9.75593 8.40387L9.35331 8.91691C8.85482 8.36587 8.1598 8.62239 8.1598 9.03567C8.1598 9.24469 8.28922 9.36345 8.74937 9.52496C9.62173 9.83849 9.88056 10.1188 9.88056 10.7411C9.88056 12.1424 8.0208 12.5177 7.16762 11.2779L7.66131 10.8076C7.83866 11.1448 8.13584 11.3206 8.50012 11.3206ZM3.63504 11.9192H2.51344V8.02384H3.63504C4.88606 8.02384 5.74883 8.83141 5.74883 9.97625C5.74883 10.8551 5.11613 11.9192 3.63504 11.9192ZM6.87044 11.9192H6.10353V8.02384H6.87044V11.9192ZM4.53137 9.00242C4.28212 8.76965 3.97536 8.68889 3.48166 8.68889H3.28035V11.2636H3.48166C3.97536 11.2636 4.2965 11.1686 4.53137 10.9596C4.80458 10.7126 4.95796 10.3515 4.95796 9.97625C4.95796 9.60097 4.80458 9.23994 4.53137 9.00242Z",
    fill: "#272020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6602 10C17.6602 8.83142 16.7064 7.88135 15.5225 7.88135C14.3433 7.88135 13.3847 8.82667 13.3847 10C13.3847 11.1686 14.3385 12.1187 15.5225 12.1187C16.7016 12.1187 17.6602 11.1734 17.6602 10Z",
    fill: "url(#paint1_linear_24485_183161)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6602 10C17.6602 8.83142 16.7064 7.88135 15.5225 7.88135C14.3433 7.88135 13.3847 8.82667 13.3847 10C13.3847 11.1686 14.3385 12.1187 15.5225 12.1187C16.7016 12.1187 17.6602 11.1734 17.6602 10Z",
    fill: "url(#paint2_radial_24485_183161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24485_183161",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24485_183161",
    x1: 14.3435,
    y1: 8.19407,
    x2: 16.6692,
    y2: 11.9517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9202"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_24485_183161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7727 11.7418) rotate(-120.579) scale(4.29009 4.25015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#272020",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272020",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCardIcon);
export default __webpack_public_path__ + "static/media/discover-card-icon.47358b176757339e3b8ebee0d56c7a16.svg";
export { ForwardRef as ReactComponent };